document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (!trigger) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
});

document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const trigger = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!trigger || !menu) return;
  trigger.setAttribute('aria-expanded', 'false');
  menu.hidden = true;
});
